// The connector URL a new token goes into. The origin is the page's own, so it is
// the public host in production and localhost in dev.
export const mcpUrl = (origin: string, token: string): string => `${origin.replace(/\/+$/, "")}/mcp/${token}`;
